import styled from 'styled-components';

import { CommonAction, recipesCommonAction, styledTypography } from '@pkg/primitives';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
`;

export const ResultsText = styled.div`
    font-size: 16px;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -0.02em;
    color: rgb(255, 255, 255, 0.5);
    white-space: nowrap;

    @media (max-width: 768px) {
        width: 100%;
        font-size: 14px;
    }
`;

export const ClearAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    padding: 4px;
    text-decoration: underline 1px currentColor;
    color: rgb(255, 255, 255, 0.6);

    &:hover:not(:active) {
        color: rgb(255, 255, 255, 0.8);
    }
`;

export const ClearActionLabel = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    display: block;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: -0.02em;
    color: currentColor;
`;
